/**
 * BrandMark — official Smart Premium Spices logo on transparent background.
 * Used in header and footer. Sized large enough to read at a glance.
 */
const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_blend-luxe-2/artifacts/krfsr7ig_SMART_LOGO_Tranparent%20bg.png";

const SIZES = {
  sm: "h-20",
  md: "h-28",
  lg: "h-36",
};

const BrandMark = ({ size = "md", className = "" }) => {
  const h = SIZES[size] || SIZES.md;

  return (
    <span
      data-testid="brand-mark"
      aria-label="Smart Premium Spices"
      className={`relative inline-flex items-center ${className}`}
    >
      <img
        src={LOGO_URL}
        alt="Smart Premium Spices"
        className={`${h} w-auto object-contain drop-shadow-[0_6px_22px_rgba(166,24,29,0.4)]`}
        draggable={false}
      />
    </span>
  );
};

export default BrandMark;
